"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosSerialCreateInputSchema = exports.APosSerialSchema = exports.APosSerialStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosSerialStatusSchema = zod_1.z.enum([
    'in_stock', 'sold', 'returned', 'damaged', 'warranty_claim', 'disposed',
]);
exports.APosSerialSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    serialId: id_schema_1.EntityIdSchema,
    serialNumber: zod_1.z.string().min(1).max(100),
    variantId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    warrantyStartDate: zod_1.z.number().optional(),
    warrantyEndDate: zod_1.z.number().optional(),
    warrantyProvider: zod_1.z.string().optional(),
    soldAt: zod_1.z.number().optional(),
    soldToCustomerId: id_schema_1.EntityIdSchema.optional(),
    orderId: id_schema_1.EntityIdSchema.optional(),
    returnedAt: zod_1.z.number().optional(),
    returnId: id_schema_1.EntityIdSchema.optional(),
    batchId: id_schema_1.EntityIdSchema.optional(),
    grnId: id_schema_1.EntityIdSchema.optional(),
    status: exports.APosSerialStatusSchema.default('in_stock'),
    notes: zod_1.z.string().max(500).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosSerialCreateInputSchema = zod_1.z.object({
    serialNumber: zod_1.z.string().min(1).max(100),
    variantId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    warrantyStartDate: zod_1.z.number().optional(),
    warrantyEndDate: zod_1.z.number().optional(),
    warrantyProvider: zod_1.z.string().optional(),
    batchId: id_schema_1.EntityIdSchema.optional(),
    grnId: id_schema_1.EntityIdSchema.optional(),
    notes: zod_1.z.string().max(500).optional(),
});
//# sourceMappingURL=serial.schema.js.map